export default __webpack_public_path__ + "static/media/REFIN_PRESTIGIO_STATUARIO_APUANO_MESH.c76144f7.jpg";